import { Component, ViewChild, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { Apollo, QueryRef, gql } from 'apollo-angular';
import { Router } from '@angular/router';
//servicios
import { DocumentoService } from 'src/app/services/documento.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { LoginService } from 'src/app/services/login.service';
import { GestorService } from 'src/app/services/gestor.service';
import { element } from 'protractor';
import { TransportistaService } from 'src/app/services/transportista.service';
import { CentroService } from 'src/app/services/centro.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { InstalacionService } from 'src/app/services/instalacion.service';
import { debug } from 'console';
/* import ChartDataLabels from 'chartjs-plugin-datalabels'; */

@Component({
  selector: 'app-inicio-entidades',
  templateUrl: './inicio-entidades.component.html',
  styleUrls: ['./inicio-entidades.component.scss'],
})
export class InicioEntidadesComponent implements OnInit {
  @ViewChild('doughnutCanvasInstalaciones') doughnutCanvasInstalaciones: any;
  @ViewChild('doughnutCanvasCentros') doughnutCanvasCentros: any;
  @ViewChild('doughnutCanvasClientes') doughnutCanvasClientes: any;
  @ViewChild('doughnutCanvasContratistas') doughnutCanvasContratistas: any;
  @ViewChild('doughnutCanvasGestores') doughnutCanvasGestores: any;
  @ViewChild('doughnutCanvasTransportistas') doughnutCanvasTransportistas: any;
  @ViewChild('doughnutCanvasDocumentos') doughnutCanvasDocumentos: any;

  title_instalaciones = 'Instalaciones';
  title_centros = 'Centros';
  title_clientes = 'Clientes';
  title_contratistas = 'Contratistas';
  title_gestores = 'Gestores';
  title_transportistas = 'Transportistas';
  title_documentos = 'Documentos';

  barChart: any;
  doughnutChart: any;
  lineChart: any;
  doughnutChartInstalaciones: any;
  doughnutChartCentros: any;
  doughnutChartClientes: any;
  doughnutChartContratistas: any;
  doughnutChartGestores: any;
  doughnutChartTransportistas: any;
  doughnutChartDocumentos: any;

  transportistasRojos: any = [];
  transportistasVerdes: any = [];
  transportistasAmarillos: any = [];

  gestoresRojos: any = [];
  gestoresVerdes: any = [];
  gestoresAmarillos: any = [];

  centrosRojos: any = [];
  centrosVerdes: any = [];
  centrosAmarillos: any = [];

  clientesRojos: any = [];
  clientesVerdes: any = [];
  clientesAmarillos: any = [];

  contratistasRojos: any = [];
  contratistasVerdes: any = [];
  contratistasAmarillos: any = [];

  instalacionRojos: any = [];
  instalacionVerdes: any = [];
  instalacionAmarillos: any = [];

  loading: any;
  documentos: any;
  docPendientes: any;
  tDocumentos: any;
  gDocumentos: any;
  cDocumentos: any;
  contratistasDocumentos: any;
  docCentro: any[] = [];

  constructor(
    private router: Router,
    private apollo: Apollo,
    private contratistaService: ContratistaService,
    private loginservice: LoginService,
    private documentoService: DocumentoService,
    private transportistaService: TransportistaService,
    private gestoresService: GestorService,
    private centroService: CentroService,
    private clienteService: ClienteService,
    private instalacionService: InstalacionService
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit() {
    this.getAllDocumentos();
    this.getTransportistas();
    this.getClientes();

    this.getGestores();
    this.getCentros();
    this.getContratistas();
    this.getInstalaciones();


  }

  validarUltimoEstado(data: any) {
    let result = data.map((item: any) => {
      let docsRojos = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "rojo");
      let docsAmarillos = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "amarillo");
      let docsVerdes = item.documentos.filter((doc: any) => (doc.tipo === 'activo' || doc.tipo === 'enEspera') && doc.estado === "verde");
      if (docsRojos.length > 0)
        return {
          id: item.id,
          estado: "rojo"
        }
      else if (docsAmarillos.length > 0 && docsRojos.length === 0)
        return {
          id: item.id,
          estado: "amarillo"
        }
      else if (docsVerdes.length > 0 && docsAmarillos.length === 0 && docsRojos.length === 0)
        return {
          id: item.id,
          estado: "verde"
        }
      else {
        return {
          id: item.id,
          estado: "rojo"
        }
      }
    })
    return result;
  }

  getAllDocumentos() {
    this.apollo
      .watchQuery<any>({
        query: this.documentoService.getAllDocumentosValidadosDoughnut(),
        fetchPolicy: 'no-cache',
      })
      .valueChanges.subscribe(({ data, loading, errors }) => {
        this.loading = loading;
        this.documentos = data.documentos;
        /* console.log(this.documentos) */
        const documentosActivos = this.documentos.filter(
          (documento: any) =>
            documento.tipo === 'haciendaActivo' ||
            documento.tipo === 'seguridadSocialActivo' ||
            documento.tipo === 'activo' ||
            documento.tipo === 'haciendaActivoEnEspera' ||
            documento.tipo === 'seguridadSocialActivoEnEspera' ||
            documento.tipo === 'enEspera'
        );

        /* console.log(documentosActivos) */
        const docCaducado = documentosActivos.filter(
          (doc: any) => doc.caducado
        );
        const docEnFecha = documentosActivos.filter(
          (doc: any) => doc.enFecha || doc.noCaduca
        );
        const docProxCaduca = documentosActivos.filter(
          (doc: any) => doc.proximoCaduca
        );
        /* console.log(docCaducado) */
        const dataDocumentos = [
          Object.keys(docEnFecha).length,
          Object.keys(docProxCaduca).length,
          Object.keys(docCaducado).length,
        ];
        this.doughnutChartDocumentosMethod(dataDocumentos);
      });
  }

  getTransportistas() {
    this.apollo
      .watchQuery<any>({
        query: this.transportistaService.getAllTransportistasDoughnout(),
        fetchPolicy: 'no-cache',
      })
      .valueChanges.subscribe(({ data, loading, errors }) => {

        const transportistas = data.transportistas;
        let checkUltimoEstado = this.validarUltimoEstado(transportistas)

        checkUltimoEstado.forEach((transportista: any) => {

          switch (transportista.estado) {
            case 'rojo':
              this.transportistasRojos.push(transportista);
              break;
            case 'amarillo':
              this.transportistasAmarillos.push(transportista);
              break;
            case 'verde':
              this.transportistasVerdes.push(transportista);
              break;
            default:
              break;
          }

        });

        this.doughnutChartTransportistasMethod();
      });
  }

  getGestores() {
    this.apollo
      .watchQuery<any>({
        query: this.gestoresService.getAllGestoresDoughtnout(),
        fetchPolicy: 'no-cache'
      })
      .valueChanges.subscribe(({ data, loading, errors }) => {
        const gestores = data.gestors;

        let checkUltimoEstado = this.validarUltimoEstado(gestores)

        checkUltimoEstado?.forEach((gestor: any) => {

          switch (gestor.estado) {
            case 'rojo':
              this.gestoresRojos.push(gestor);
              break;
            case 'amarillo':
              this.gestoresAmarillos.push(gestor);
              break;
            case 'verde':
              this.gestoresVerdes.push(gestor);
              break;
          }
        });
        this.doughnutChartGestoresMethod();
      });
  }

  checkUltimoEstado(data: any) {
    data.forEach((item: any) => {
      let filtrados = item.documentos.filter((doc: any) => doc.tipo === "activo" || doc.tipo === "enEspera");
      let rojos = filtrados.some((r: any) => r.estado === "rojo");
      let amarillos = filtrados.some((y: any) => y.estado === "amarilo");
      let verdes = filtrados.some((g: any) => g.estado === "verde");
      if (rojos)
        item.estado = "rojo"
      else if (amarillos && !rojos)
        item.estado = "amarillo"
      else if (verdes && !amarillos && !rojos)
        item.estado = "verde"
    })
  }

  getCentros() {
    this.apollo.watchQuery<any>({
      query: this.centroService.getAllCentrosDoughnout(),
      fetchPolicy: 'no-cache'

    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        let allCondicion = []
        const centros = data.centros
        centros?.forEach((centro: any) => {
          let filtrados = centro.documentos.filter((doc: any) =>
            doc.tipo === "activo" || doc.tipo === "esEspera"
          )
          if (filtrados.length === 0) {
            centro.estado = "rojo"
          } else {
            let hasDocsRojo = filtrados.some((cent: any) => cent.estado === "rojo")
            if (!hasDocsRojo) {
              this.checkUltimoEstado(centro.gestors)
              this.checkUltimoEstado(centro.transportistas)
              let allCondicion = [...centro.gestors, ...centro.transportistas]
              this.checkTiposDocumentos(allCondicion, centro)
            } else {
              centro.estado = "rojo"
            }
          }
          switch (centro.estado) {
            case 'rojo':
              this.centrosRojos.push(centro)
              break;
            case 'amarillo':
              this.centrosRojos.push(centro)
              break;
            case 'verde':
              this.centrosVerdes.push(centro)
              break;
          }

        });
        this.doughnutChartCentrosMethod()
      }
      )
  }

  checkTiposDocumentos(data: any[], obj: any) {
    let reds = data.some((i: any) => i.estado === "rojo")
    let yellows = data.some((i: any) => i.estado === "amarillo")
    let greens = data.some((i: any) => i.estado === "verde")
    if (reds)
      obj.estado = "rojo"
    else if (yellows && !reds)
      obj.estado = "amarillo"
    else if (greens && !yellows && !reds)
      obj.estado = "verde"
  }

  getClientes() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getAllClientesDougtnout(),
      fetchPolicy: "no-cache",
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const clientes = data.clientes
        clientes.forEach((cliente: any) => {
          this.checkUltimoEstado(cliente.centros)
          let hasDocumentosRojos = cliente.centros.some((cent: any) => cent.estado === "rojo")
          if (!hasDocumentosRojos) {
            //chequear docuementos de gestores y transportistas por centro
            cliente.centros.forEach((centro: any) => {
              this.checkUltimoEstado(centro.gestors)
              this.checkUltimoEstado(centro.transportistas)
              let allTranspYGestores = [...centro.gestors, ...centro.transportistas]
              this.checkTiposDocumentos(allTranspYGestores, centro)
            })
            this.checkTiposDocumentos(cliente.centros, cliente)
          } else {
            cliente.estado = "rojo";
          }
        })
        clientes?.forEach((cliente: any) => {
          switch (cliente?.estado) {
            case 'rojo':
              this.clientesRojos.push(cliente);
              break;

            case 'amarillo':
              this.clientesAmarillos.push(cliente)
              break;

            case 'verde':
              this.clientesVerdes.push(cliente);
              break;
          }
        });
        this.doughnutChartClientesMethod();
      }
      )
  }


  updateClienteById(id: any, estado: any) {
    this.apollo.mutate({
      mutation: this.clienteService.updateCliente(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "estado": estado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })


  }
  getContratistas() {
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getAllContratistasDoughnout(),
      fetchPolicy: 'no-cache',
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const contratistas = data.contratistas
        contratistas?.forEach((contratista: any) => {
          let filtrados = contratista.documentos.filter((doc: any) => doc.tipo === 'activo'
            || doc.tipo === 'enEspera'
            || doc.tipo === 'seguridadSocialActivoEnEspera'
            || doc.tipo === 'seguridadSocialActivo'
            || doc.tipo === 'haciendaActivo'
            || doc.tipo === 'haciendaActivoEnEspera')
          if (filtrados.length === 0) {
            contratista.estado = "rojo"
          }
          else {
            this.checkTiposDocumentos(filtrados, contratista)
            let hasDocumentosAmarillos = filtrados.some((cent: any) => cent.estado === "amarillo")
            if (hasDocumentosAmarillos) {
              contratista.estado = "amarillo"
            }
            let hasDocumentosRojos = filtrados.some((cent: any) => cent.estado === "rojo")
            if (!hasDocumentosRojos && !hasDocumentosAmarillos) {
              //chequear documentos de centro
              contratista.centros.forEach((centro: any) => {
                let filtradosCentro = centro.documentos.filter((doc: any) =>
                  doc.tipo === "activo" || doc.tipo === "esEspera"
                )
                if (filtradosCentro.length === 0) {
                  centro.estado = "rojo"
                } else {
                  let hasDocsRojo = filtradosCentro.some((cent: any) => cent.estado === "rojo")
                  if (!hasDocsRojo) {
                    this.checkUltimoEstado(centro.gestors)
                    this.checkUltimoEstado(centro.transportistas)
                    let gestoresYTransp = [...centro.gestors, ...centro.transportistas];
                    this.checkTiposDocumentos(gestoresYTransp, centro)
                  } else {
                    centro.estado = "rojo"
                  }
                }
              })
              this.checkTiposDocumentos(contratista.centros, contratista)
            } else if (hasDocumentosRojos) {
              contratista.estado = "rojo"
            }
          }


          switch (contratista.estado) {
            case 'rojo':
              this.contratistasRojos.push(contratista)

              break;
            case 'amarillo':
                this.contratistasAmarillos.push(contratista)
              break;
            case 'verde':
                this.contratistasVerdes.push(contratista)
              break;

          }


        });
        this.doughnutChartContratistasMethod()
      }
      )
  }



  updateContratistaById(id: any, estado: any) {
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "estado": estado
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getInstalaciones() {
    this.apollo.watchQuery<any>({
      query: this.instalacionService.getAllInstalacionesDoughnout(),
      fetchPolicy: "no-cache"
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        const instalaciones = data.instalacions

        instalaciones?.forEach((instalacion: any) => {
          let filtrados = instalacion.centro.documentos.filter((doc: any) =>
            doc.tipo === "activo" || doc.tipo === "esEspera"
          )
          if (filtrados.length === 0) {
            instalacion.centro.estado = "rojo"
          } else {
            let hasDocsRojos = filtrados.some((cent: any) => cent.estado === "rojo")
            if (!hasDocsRojos) {
              this.checkUltimoEstado(instalacion.centro.gestors)
              this.checkUltimoEstado(instalacion.centro.transportistas)
              let transpYGestores = [...instalacion.centro.transportistas, ...instalacion.centro.gestors]
              this.checkTiposDocumentos(transpYGestores, instalacion.centro)
            } else {
              instalacion.centro.estado = "rojo"
            }
          }
          switch (instalacion?.centro?.estado) {
            case 'rojo':
              this.instalacionRojos.push(instalacion)
              break;
            case 'amarillo':
              this.instalacionAmarillos.push(instalacion)
              break;
            case 'verde':
              this.instalacionVerdes.push(instalacion)
              break;

          }
        });
        this.doughnutChartInstalacionesMethod()
      }
      )
  }


  doughnutChartInstalacionesMethod() {
    const data = [
      this.instalacionVerdes.length,
      this.instalacionAmarillos.length,
      this.instalacionRojos.length,
    ];
    this.doughnutChartInstalaciones = new Chart(
      this.doughnutCanvasInstalaciones.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,

              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }

  doughnutChartCentrosMethod() {
    const data = [
      this.centrosVerdes.length,
      this.centrosAmarillos.length,
      this.centrosRojos.length,
    ];

    this.doughnutChartCentros = new Chart(
      this.doughnutCanvasCentros.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,
              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }

  doughnutChartClientesMethod() {
    const data = [
      this.clientesVerdes.length,
      this.clientesAmarillos.length,
      this.clientesRojos.length,
    ];
    this.doughnutChartClientes = new Chart(
      this.doughnutCanvasClientes.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,
              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }

  doughnutChartContratistasMethod() {
    const data = [
      this.contratistasVerdes.length,
      this.contratistasAmarillos.length,
      this.contratistasRojos.length,
    ];
    this.doughnutChartContratistas = new Chart(
      this.doughnutCanvasContratistas.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,
              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }

  doughnutChartGestoresMethod() {
    const data = [
      this.gestoresVerdes.length,
      this.gestoresAmarillos.length,
      this.gestoresRojos.length,
    ];
    this.doughnutChartGestores = new Chart(
      this.doughnutCanvasGestores.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,

              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }

  doughnutChartTransportistasMethod() {
    const data = [
      this.transportistasVerdes.length,
      this.transportistasAmarillos.length,
      this.transportistasRojos.length,
    ];
    this.doughnutChartTransportistas = new Chart(
      this.doughnutCanvasTransportistas.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,
              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }
  doughnutChartDocumentosMethod(data: any) {
    this.doughnutChartDocumentos = new Chart(
      this.doughnutCanvasDocumentos.nativeElement,
      {
        type: 'doughnut',

        data: {
          labels: ['Correcto', 'Próximo a caducar', 'Caducado'],
          datasets: [
            {
              label: 'Estados',
              data: data,
              backgroundColor: ['#00A131', '#FF9E00', '#DC3737'],
              hoverBackgroundColor: ['#308F70', '#EDB355', '#EE5B5B'],
            },
          ],
        },
      }
    );
  }

  //FILTRO POR COLOR ROSCOS DOCUMENTOS A TABLA
  showDataDocumentos(evt: any) {
    let data = this.doughnutChartDocumentos.getElementsAtEvent(evt)
    console.log(data[0]._model.backgroundColor)
    switch (data[0]._model.backgroundColor) {

      case '#EDB355':
        this.router.navigate(['/inproeco/estado/documentacion-proxima']);
        break;
      case '#EE5B5B':
        this.router.navigate(['/inproeco/estado/documentacion-caducada']);
        break;

      default:
        break;
    }

  }

  //FILTRO POR COLOR ROSCO GESTORES A TABLA

  showDataGestores(evt: any) {
    let data = this.doughnutChartGestores.getElementsAtEvent(evt)
    console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenGestor()
        break;
      case '#EDB355':
        this.filterYellowGestor()
        break;
      case '#EE5B5B':
        this.filterRedGestor()
        break;

      default:
        break;
    }

  }

  filterYellowGestor() {

    this.apollo.watchQuery<any>({
      query: this.gestoresService.getAllGestoresYellow(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.gestoresService.setGestores(data.gestors)
        this.router.navigate(['/inproeco/estado/gestores']);
      })

  }

  filterGreenGestor() {

    this.apollo.watchQuery<any>({
      query: this.gestoresService.getAllGestoresGreen(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.gestoresService.setGestores(data.gestors)
        this.router.navigate(['/inproeco/estado/gestores']);
      })

  }

  filterRedGestor() {

    this.apollo.watchQuery<any>({
      query: this.gestoresService.getAllGestoresRed(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.gestoresService.setGestores(data.gestors)
        this.router.navigate(['/inproeco/estado/gestores']);
      })

  }

  //FILTRO POR COLOR ROSCO TRANSPORTISTAS A TABLA

  showDataTransportistas(evt: any) {
    let data = this.doughnutChartTransportistas.getElementsAtEvent(evt)
    console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenTransportista()
        break;
      case '#EDB355':
        this.filterYellowTransportista()
        break;
      case '#EE5B5B':
        this.filterRedTransportista()
        break;

      default:
        break;
    }

  }

  filterYellowTransportista() {

    this.apollo.watchQuery<any>({
      query: this.transportistaService.getAllTransportistasYellow(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.transportistaService.setTransportistas(data.transportistas)
        this.router.navigate(['/inproeco/estado/transportistas']);
      })

  }

  filterGreenTransportista() {

    this.apollo.watchQuery<any>({
      query: this.transportistaService.getAllTransportistasGreen(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.transportistaService.setTransportistas(data.transportistas)
        this.router.navigate(['/inproeco/estado/transportistas']);
      })

  }

  filterRedTransportista() {

    this.apollo.watchQuery<any>({
      query: this.transportistaService.getAllTransportistasRed(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.transportistaService.setTransportistas(data.transportistas)
        this.router.navigate(['/inproeco/estado/transportistas']);
      })

  }

  //FILTRO POR COLOR ROSCO CONTRATISTAS A TABLA

  showDataContratistas(evt: any) {
    let data = this.doughnutChartContratistas.getElementsAtEvent(evt)
    console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenContratista()
        break;
      case '#EDB355':
        this.filterYellowContratista()
        break;
      case '#EE5B5B':
        this.filterRedContratista()
        break;

      default:
        break;
    }

  }

  filterYellowContratista() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getAllContratistasYellow(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.contratistaService.setContratistas(data.contratistas)
        this.router.navigate(['/inproeco/estado/contratistas']);
      })

  }

  filterGreenContratista() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getAllContratistasGreen(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.contratistaService.setContratistas(data.contratistas)
        this.router.navigate(['/inproeco/estado/contratistas']);
      })

  }

  filterRedContratista() {

    this.apollo.watchQuery<any>({
      query: this.contratistaService.getAllContratistasRed(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data);

        this.contratistaService.setContratistas(data.contratistas)
        this.router.navigate(['/inproeco/estado/contratistas']);
      })




  }


  showDataClientes(evt: any) {
    let data = this.doughnutChartClientes.getElementsAtEvent(evt)
    console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenCliente()
        break;
      case '#EDB355':
        this.filterYellowCliente()
        break;
      case '#EE5B5B':
        this.filterRedCliente()
        break;

      default:
        break;
    }

  }

  filterYellowCliente() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getAllClientesYellow(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.clienteService.setClientes(data.clientes)
        this.router.navigate(['/inproeco/estado/clientes']);
      })

  }

  filterGreenCliente() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getAllClientesGreen(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.clienteService.setClientes(data.clientes)
        this.router.navigate(['/inproeco/estado/clientes']);
      })

  }

  filterRedCliente() {

    this.apollo.watchQuery<any>({
      query: this.clienteService.getAllClientesRed(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data);

        this.clienteService.setClientes(data.clientes)
        this.router.navigate(['/inproeco/estado/clientes']);
      })

  }


  showDataCentros(evt: any) {
    let data = this.doughnutChartCentros.getElementsAtEvent(evt)
    console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenCentro()
        break;
      case '#EDB355':
        this.filterYellowCentro()
        break;
      case '#EE5B5B':
        this.filterRedCentro()
        break;

      default:
        break;
    }

  }

  filterYellowCentro() {

    this.apollo.watchQuery<any>({
      query: this.centroService.getAllCentrosYellow(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.centroService.setCentros(data.centros)
        this.router.navigate(['/inproeco/estado/centros']);
      })

  }

  filterGreenCentro() {

    this.apollo.watchQuery<any>({
      query: this.centroService.getAllCentrosGreen(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.centroService.setCentros(data.centros)
        this.router.navigate(['/inproeco/estado/centros']);
      })

  }

  filterRedCentro() {

    this.apollo.watchQuery<any>({
      query: this.centroService.getAllCentrosRed(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data);
        console.log(1);

        this.centroService.setCentros(data.centros)
        this.router.navigate(['/inproeco/estado/centros']);
      })

  }

  showDataInstalaciones(evt: any) {
    let data = this.doughnutChartInstalaciones.getElementsAtEvent(evt)
    console.log(data[0]._model);
    switch (data[0]._model.backgroundColor) {
      case '#308F70':
        this.filterGreenInstalacion()
        break;
      case '#EDB355':
        this.filterYellowInstalacion()
        break;
      case '#EE5B5B':
        this.filterRedInstalacion()
        break;

      default:
        break;
    }

  }

  filterYellowInstalacion() {

    this.apollo.watchQuery<any>({
      query: this.instalacionService.getAllInstalacionesYellow(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.instalacionService.setInstalaciones(data.instalacions)
        this.router.navigate(['/inproeco/estado/instalaciones']);
      })

  }

  filterGreenInstalacion() {

    this.apollo.watchQuery<any>({
      query: this.instalacionService.getAllInstalacionesGreen(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data)
        this.instalacionService.setInstalaciones(data.instalacions)
        this.router.navigate(['/inproeco/estado/instalaciones']);
      })

  }

  filterRedInstalacion() {

    this.apollo.watchQuery<any>({
      query: this.instalacionService.getAllInstalacionesRed(),
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        console.log(data);
        this.instalacionService.setInstalaciones(data.instalacions)
        this.router.navigate(['/inproeco/estado/instalaciones']);
      })

  }


}
